<template>
    <div id="dearGame">
        <headerPage :title="title" :iconSrc="iconSrc" :headerSty="headerSty"></headerPage>
        <headerBg :headerBg="headerBg" class="headerBg"></headerBg>
        <gameImg :game="game"></gameImg>
        <div class="text">
            <div v-if="$route.query.type != 'epic'">这是你今年买的最贵的游戏</div>
            <div v-if="$route.query.type == 'epic' && !$route.query.shareRef">这是你今年白嫖游戏中价格最高的！</div>
            <div v-if="$route.query.type == 'epic' && $route.query.shareRef">这是'TA'今年白嫖游戏中价格最高的！</div>
            <div v-if="$route.query.type != 'epic'">
                它居然价值<span class="span3" :style="colorSty">¥</span
                ><span class="span1" :style="colorSty">{{ data.gamePrice }}</span>
            </div>
            <div v-if="$route.query.type == 'epic'">
                它居然价值<span class="span3" :style="colorSty">¥</span
                ><span class="span1" :style="colorSty">{{ data.mostFreeGameValue }}</span>
            </div>
            <div v-if="$route.query.type != 'epic'">
                总共游玩 <span class="span1" :style="colorSty">{{ data.playHour }}</span
                ><span class="span2" :style="colorSty">h</span> 平均每小时<span class="span3" :style="colorSty">¥</span
                ><span class="span1" :style="colorSty">{{ data.avePrice }}</span>
            </div>
            <div v-if="$route.query.type != 'epic'">
                <span>{{ data.text }}</span><img src="../../assets/image/steam/right_big.png" />
            </div>
            <div v-if="$route.query.type == 'epic'">
                <span>{{ data.mostFreeGameText }}</span
                ><img src="../../assets/image/steam/right_big.png" />
            </div>
        </div>
        <footerPage class="footerPage"></footerPage>
        <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
    </div>
</template>

<script>
import headerPage from "../../components/header.vue";
import gameImg from "../../components/gameImg.vue";
import footerPage from "../../components/footer.vue";
import footerBg from "../../components/footerBg.vue";
import headerBg from "../../components/headerBg.vue";
import { numberToCurrency } from "../../assets/js/numberToCurrency";
export default {
    filters: {
        numberToCurrency
    },
    props: {
        data: {
            type: [Object]
        }
    },
    data() {
        return {
            title: "年度剁手游戏",
            iconSrc: require("../../assets/image/" +
                this.$route.query.type +
                "/" +
                this.$route.query.type +
                "_small.png"),
            headerSty: {
                padding: "7.2rem 0 0 1.95rem"
            },
            footerBg: {
                top: "25rem",
                height: "17rem",
                background: "url(" + require("../../assets/image/" + this.$route.query.type + "/dearGameBg.png") + ")",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
                // backgroundAttachment: 'fixed',
            },
            headerBg: {
                height: "12.45rem",
                background: "url(" + require("../../assets/image/steam/headerBg.png") + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "300%",
                backgroundPosition: "8% 15%"
                // backgroundAttachment: 'fixed',
            },
            game: {},
            colorSty: {}
        };
    },
    mounted() {
        if (this.$route.query.type == "steam") {
            this.colorSty = {
                color: "#5EE6FF"
            };
            this.$set(this.game, "gameImg", this.data.gameCover);
            this.$set(this.game, "gameName", this.data.gameName);
        } else if (this.$route.query.type == "psn") {
            this.colorSty = {
                color: "#5EA6FF"
            };
            this.$set(this.game, "gameImg", this.data.gameCover);
            this.$set(this.game, "gameName", this.data.gameName);
        } else if (this.$route.query.type == "xbox") {
            this.colorSty = {
                color: "#5EFF97"
            };
            this.$set(this.game, "gameImg", this.data.gameCover);
            this.$set(this.game, "gameName", this.data.gameName);
        } else if (this.$route.query.type == "epic") {
            this.colorSty = {
                color: "#FF5E5E"
            };
            this.title = "年度血赚游戏";
            this.$set(this.game, "gameImg", this.data.mostFreeGameCover);
            this.$set(this.game, "gameName", this.data.mostFreeGameName);
        }
    },

    methods: {
        getNumber(val) {
            if (val) {
                return val.toFixed(0);
            }
        }
    },
    components: {
        headerPage,
        gameImg,
        footerPage,
        footerBg,
        headerBg
    }
};
</script>

<style>
#dearGame .text {
    padding: 0 1.95rem;
    font-size: 0.7rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
}
#dearGame .text div {
    margin-bottom: 1.35rem;
}
#dearGame .text .span1 {
    font-size: 1.4rem;
    font-family: Impact;
    color: #5ee6ff;
    margin-left: 0.3rem;
}
#dearGame .text .span2 {
    font-size: 0.7rem;
    font-family: Source Han Sans CN;
    color: #5ee6ff;
    margin-left: 0.35rem;
}
#dearGame .text .span3 {
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    color: #5ee6ff;
    margin-left: 0.7rem;
}
#dearGame .text > div:last-child {
    display: flex;
    align-items: end;
    justify-content: space-between;
}
#dearGame .text > div:last-child > span {
    margin-bottom: 0.15rem;
}
#dearGame .text img {
    width: 1.8rem;
    height: 1.5rem;
}
</style>
